import React from 'react'
import {observer} from 'mobx-react-lite'
import iconsUrl from './config/iconsUrl.json'
import basicIcons from './config/basicIcons.json'
import {IconBase, IconProps} from './IconBase'

export const iconList: {s2aName: string; ocName?: string}[] = Object.keys(iconsUrl).map(s2aKey => {
    const ocName = Object.entries(basicIcons).find(item => item[1] === s2aKey)
    return {s2aName: s2aKey, ocName: ocName ? ocName[0] : undefined}
})

const iconKeys = iconList.map(icon => icon.s2aName)
export type IconKeyType = (typeof iconKeys)[number]

export type IconByKeyProps = IconProps & {iconKey: IconKeyType; 'data-cy'?: string}

function _IconByKey({iconKey, ...restProps}: IconByKeyProps) {
    const existingUrl = React.useMemo<string | undefined>(() => {
        const iconItem = Object.entries(iconsUrl).find(item => item[0] === iconKey)
        return iconItem ? iconItem[1] : undefined
    }, [iconKey])
    if (!existingUrl) {
        return null
    }
    return <IconBase url={existingUrl} {...restProps} />
}

export const IconByKey = observer(_IconByKey)
